import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import ParentLetter from './ParentLetter';
import parentLetterStyles from './parentLetterStyles';
import { useLocalTranslation } from '../../../../../i18n/i18n';

export default function ParentLetterPrintWrapper(props) {
  const {parentLetterData, includeActivityLog, printLocale} = props;

  const {t} = useLocalTranslation(printLocale, ['teacher_dyslexia_letter', 'teacher_parent_report']);

  const roster = useSelector(state => state.reports.roster);
  
  if (!parentLetterData) return null;
  
  // append school name to parentLetterData
  const schoolName = get(roster, 'ui.selections.school.label', '');
  parentLetterData.forEach(letter => letter.schoolName = schoolName);
  
  return (
    <React.Fragment>
      <div id="parentLetterPrintWrapper" style={{display: 'none'}}>
        {parentLetterData.map((letter, i) => 
          <ParentLetter 
            key={i}
            {...letter}
            includeActivityLog={includeActivityLog}
            t={t}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export function printParentLetters() {
  let id = 'parentLetterPrintWrapper';
  const lettersHTMLContent = document.getElementById(id).innerHTML;
  const printWindowHtml = `
  <html>
    <head>
      <style type="text/css">${parentLetterStyles}</style>
    </head>
    <body>${lettersHTMLContent}</body>
  </html>`

  const printWindow = window.open('');
  printWindow.document.write(printWindowHtml);
  printWindow.document.close(); // necessary for IE >= 10
  printWindow.document.body.onload = () => {
    printWindow.focus(); // necessary for IE >= 10
    printWindow.print();
    printWindow.close();
  }
}